const translations = {
    emailAddressFieldLabel: 'Email'
};

export default translations;
